import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_CALENDAR_DATA } from "src/api-setup/api-endpoints";

/*
 * Calendar periods belonging to one period type, most recent first. Earnings
 * Overview highlights the period containing today, falling back to the first
 * row when today's period is not present.
 *
 * Ported from useSelectCalendar in the mobile app.
 */
export const getCalendarPeriods = async (cookiesData, dispatch, periodTypeKey) => {
  if (!cookiesData || !periodTypeKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: `AND a.period_type_mstr_key = ${periodTypeKey}`,
      in_sort_number: null,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 9999,
      in_sort_number_concat: "a.period_end_date DESC, a.period_level_order DESC",
    };

    const response = await POSTAPI(false, GET_CALENDAR_DATA, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching calendar periods:", error);
    return [];
  }
};
